import type { SalesChecklistItemDefaultExample } from "@expert/contentful";
import { usePersonalizeCoverage } from "@expert/contentful";
import { useDetectedCuesStore } from "@/sales-tools/detected-cues/stores/DetectedCuesStore";
import { CarouselWithDefault } from "@/sales-tools/home-product/components/FullOfferChecklist/components/carousels/CarouselWithDefault";
import { getDetectedDeviceExamples } from "@/sales-tools/home-product/components/FullOfferChecklist/utils/getDetectedDeviceExamples";
import { useProductOfferStore } from "@/sales-tools/home-product/stores";
import { useSessionId } from "@/sdk";

export function CoverageCarousel({ defaultExample }: { defaultExample: SalesChecklistItemDefaultExample }) {
    const sessionId = useSessionId();
    const devices = useDetectedCuesStore((state) => state.getDisplayCues(sessionId));
    const primaryProductSku = useProductOfferStore().getPrimaryProducts(sessionId).at(0)?.productSku;
    const coverageResponses = usePersonalizeCoverage(primaryProductSku);
    const examples = getDetectedDeviceExamples(devices, coverageResponses);

    return <CarouselWithDefault defaultExample={defaultExample} examples={examples} />;
}
